import { getPageRoutes } from '../page';

const Website = ({website, cartItems}) => getPageRoutes(website, cartItems)
export default Website;